import Grid from '@material-ui/core/Grid'
import React, { PropsWithChildren } from 'react'
import styled from 'styled-components'
import { FlickityComponent } from './FlickityComponent'

export type FeatureNewsCarouselWrapperProps = React.ComponentProps<typeof StyledFeatureNewsCarouselWrapper> & {
  layout?: 'vertical' | 'horizontal'
}

export const StyledFeatureNewsCarouselWrapper = styled(Grid)`
  width: 100%;
  display: flex;
  flex-direction: column;
`

export const FeatureNewsCarouselWrapper: React.FC<PropsWithChildren<FeatureNewsCarouselWrapperProps>> = ({ layout = 'vertical', children, ...props }) => {
  if (layout === 'vertical') {
    return (
      <StyledFeatureNewsCarouselWrapper {...props}
        container
        direction="column"
        justifyContent="flex-start"
        alignItems="flex-start"
      >
        <FlickityComponent
          layout={layout}
        >
          {children}
        </FlickityComponent>
      </StyledFeatureNewsCarouselWrapper>
    )
  }

  return (
    <StyledFeatureNewsCarouselWrapper {...props}
      container
      direction="column"
      justifyContent="flex-start"
      alignItems="flex-start"
    >
      <FlickityComponent
        layout={layout}
      >
        {children}
      </FlickityComponent>
    </StyledFeatureNewsCarouselWrapper>
  )
}
